import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './Dashboard.css';
import API_URLS from '../summaryapi/apiUrls';
import Custom from '../components/CustomtableToday/Custom';
import { RingLoader } from 'react-spinners';
import Charts from '../components/Charts';  // Import the new Charts component
import { FaClipboardList, FaRupeeSign, FaUser, FaClock } from 'react-icons/fa';  // Import icons

const data = {
  summary: [
    { title: 'Total Bookings', value: 100, icon: <FaClipboardList size={24} /> },  // Added icon
    { title: 'Total Revenue', value: '₹100,000', icon: <FaRupeeSign size={24} /> },  // Added FaRupeeSign icon
    { title: 'Total Customers', value: 200, icon: <FaUser size={24} /> },  // Added icon
    { title: 'Pending Bookings', value: 15, icon: <FaClock size={24} /> },  // Added icon
  ],
};

const Dashboard = () => {
  const [bookingData, setBookingData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBookingData = async () => {
    setLoading(true);

    const encodedProviderId = sessionStorage.getItem('provider_id');
    const providerId = encodedProviderId ? atob(encodedProviderId) : null;

    const url = providerId
      ? API_URLS.providerTodayBookingReport.url
      : API_URLS.getTodayBookingReport.url;

    const method = providerId ? "PUT" : API_URLS.getTodayBookingReport.method;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: providerId ? JSON.stringify({ provider_id: providerId }) : null,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch booking data');
      }

      const data = await response.json();
      const sortedData = data.data.sort((a, b) => new Date(b.booking_date) - new Date(a.booking_date));
      setBookingData(sortedData);
    } catch (error) {
      console.error('Error fetching bookings:', error);
      toast.error('Today No Bookings Found');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookingData();

    const intervalId = setInterval(fetchBookingData, 300000);

    return () => clearInterval(intervalId);
  }, []);

  if (loading) {
    return (
      <div>
        <h3 style={{ color: '#8A2BE2' }}>Loading Booking Data...</h3>
        <RingLoader color="#3498db" loading={loading} size={50} />
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      {/* First Row - Analytics Cards */}
      <div className="analytics-boxes">
        {data.summary.map((item, index) => (
          <div key={index} className={`analytics-box box-${index}`}>
            <div className="analytics-box-icon">
              {item.icon}  {/* Render the icon in the left corner */}
            </div>
            <h5>{item.title}</h5>
            <p>{item.value}</p>
          </div>
        ))}
      </div>

      {/* Second Row - Charts Component with Static Data */}
      <Charts />

      {/* Third Row - Table */}
      <div className="table-responsive">
        <Custom bookingData={bookingData} />
      </div>
    </div>
  );
};

export default Dashboard;
